import { render, staticRenderFns } from "./ConsentCancellation.vue?vue&type=template&id=5826ae67&"
import script from "./ConsentCancellation.vue?vue&type=script&lang=js&"
export * from "./ConsentCancellation.vue?vue&type=script&lang=js&"
import style0 from "./ConsentCancellation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports